
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { map, defaultArgWith, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { IKBLeitstelleReceiverPrivacyStatement } from "../CustomerSpecific.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initForm, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { singleton as singleton_1, append as append_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function SubcontractorForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("general.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "subcontractor-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Subcontractor.Name,
        })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (value) => {
                props.Dispatch(new Msg(3, [value]));
            },
            SelectedBusinessUnitId: unwrap(props.Subcontractor.BusinessUnitId),
        })) : empty()) : empty(), delay(() => {
            let Label_1, Value_1;
            return append(isFeatureEnabled(new Feature(15, [])) ? singleton(createElement(Input, (Label_1 = t("general.email"), (Value_1 = defaultArg(props.Subcontractor.Email, ""), {
                ComponentState: componentState,
                Label: unwrap(Label_1),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [arg_1]));
                },
                TestId: "subcontractor-email",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                Value: Value_1,
            })))) : empty(), delay(() => append(props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: props.Subcontractor.CustomProperties,
                FormState: props.FormState,
                OnSetCustomProperty: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                PropertyConfigurationType: new PropertyConfigurationVisibility(5, []),
                PropertyConfigurations: props.PropertyConfigurations,
            })) : empty(), delay(() => {
                if (props.Customer.tag === 9) {
                    return singleton(createElement(IKBLeitstelleReceiverPrivacyStatement, null));
                }
                else {
                    return empty();
                }
            }))));
        })))))),
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewSubcontractorView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.AccountSettings;
    const matchValue_4 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, propertyConfigurations, subcontractor;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        businessUnits = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        subcontractor = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SubcontractorForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Customer: props.Customer,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("subcontractor.create_new_subcontractor"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                OnBack: () => {
                    RouterModule_nav(ofArray(["receivers", "subcontractors" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(4, []));
                },
                PropertyConfigurations: propertyConfigurations,
                Subcontractor: subcontractor,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditSubcontractorView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initForm, update_1, (_arg, _arg_1) => {
    }), props.SubcontractorId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.AccountSettings;
    const matchValue_4 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, propertyConfigurations, subcontractor;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        businessUnits = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        subcontractor = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SubcontractorForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Customer: props.Customer,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("subcontractor.edit_subcontractor"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map((tupledArg) => {
                        RouterModule_nav(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnSave: () => {
                    dispatch(new Msg(5, []));
                },
                PropertyConfigurations: propertyConfigurations,
                Subcontractor: subcontractor,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

